<div class="flex flex-col gap-4 pt-4 min-h-[35vh]">

  <div class="flex flex-col md:flex-row md:justify-between gap-4">
    <div class="order-2 md:order-1 w-full md:w-9/12">
      <afcu-input 
        [form]="form" 
        [question]="questions[0]" 
        searchQueryType="service"
      />
    </div>

    <div class="order-1 md:order-2 w-full md:w-1/4">
      <afcu-input 
        [form]="form" 
        [question]="questions[1]" 
        (externalFunction)="selectEvent($event)"
      />
    </div>
  </div>

  @if (filtered) {
    <button id="categorySelected" class="text-gray-800 text-sm flex gap-2"(click)="resetSearch()">
      <span class="cursor-pointer inline-flex items-center gap-1 group hover:decoration-afcu-navy-800 hover:bg-afcu-navy-50 w-fit pr-2 hover:text-afcu-navy-800">
      <img src="/icons/arrow/back-black.svg"/>
      <div class="font-semibold hover:underline ">{{getText()[target].main.research}}:</div>
      </span>
      @if(categorySelected){
        <div class="font-bold hover:decoration-1 hover:decoration-afcu-navy-800">{{categorySelected}}</div>
      }
    </button>
  }

  @if(isLoading){
    <afcu-loading target="service" />
  } @else {
    <div #myServices>
      <div 
        #branchServices 
        class="servicesList rounded flex flex-col gap-4 h-fit"
        [class]="(!filtered && categoriesService.ServicesName.length ) ? 'list-categories bg-gray-200' : ''">
        @for (category of categoriesService.ServicesName; track category) {
          @if(filtered){
            <div class="flex flex-col gap-4">
              @for (service of categoriesService.items()[this.textService.language().toUpperCase()][category]; track service){
                <afcu-list [service]="service" (externalFunction)="selectEvent($event)" />
              }
            </div>
          } @else {
            <afcu-tile 
              [category]="category" 
              [services]="categoriesService.items()[this.textService.language().toUpperCase()][category].length" 
              (filter)="search(category)"
            />
          }
        } @empty {
          <afcu-empty-search [target]="target" />
        }

        @if(filtered){
          <button 
            id="clearSearch"
            class="text-afcu-navy-800 font-semibold text-sm px-5 py-2.5 cursor-pointer w-fit" 
            (click)="resetSearch()">
            {{getText().clear}}
        </button>
        }
      </div>
    </div>
  }
  
</div>
